<div class="sort-by" [ngClass]="cssClass" (click)="showOptions()" [attr.data-test]="'link-sort'">
  @if (hasTitle) {
    <div class="sort__title">
      @if (showTitle()) {
        <span [attr.data-test]="'desc-sortTitle'">
          {{ 'search-results.sorted-by' | translate }}
        </span>
      }
      @if (isActive()) {
        <span [attr.data-test]="'desc-activeSortTitle'">
          {{ activeSortLabel() }}
        </span>
      }
    </div>
  }
  <div class="selectbox width-100" [ngClass]="{'is-open has-focus': isOpen}">
    <ul class="menu selectbox__option-list">
      @for (option of sort; track option.value) {
        <li class="selectbox__option" [attr.data-test]="'option-sort-' + option.value">
          @if (current) {
            <span class="menu__item" 
                [ngClass]="[isSelected(option.name) ? 'is-selected' : '']" 
                (click)="selectSort(option)"
                [attr.data-test]="'desc-sort-' + option.value">
              {{ option.name | translate }}
            </span>
          } @else {
            <a class="menu__item" 
                [ngClass]="[isSelected(option.value) ? 'is-selected' : '' ]" 
                [routerLink]="pageUrl()" 
                [queryParams]="queryParams(option)"
                [attr.data-test]="'desc-sort-' + option.value">
              {{ option.name | translate }}
            </a>
          }
        </li>
      }
    </ul>
  </div>
</div>
